<template>
    <div class="mb-3">
        <h5 class="text-dark px-2 pt-3 pb-0 mb-0">{{ currentUser.full_name }}</h5>
        <span class="text-sm text-black-50 px-2">{{ currentUser.email }}</span>
    </div>
    <nav>
        <ul class="list-unstyled">
            <li class="d-flex align-items-center p-2">
                <i class="material-symbols-outlined text-lg mr-2">event</i>
                <a href="/my/bookings"><span>Réservations</span></a>
            </li>
            <li class="d-flex align-items-center p-2">
                <i class="material-symbols-outlined text-lg mr-2">stadium</i>
                <a v-if="this.currentUser.role == 'admin'" href="/my/establishments"><span>Espaces</span></a>
                <a v-else href="/my/establishment"><span>Espace</span></a>
            </li>
            <li class="d-flex align-items-center p-2">
                <i class="material-symbols-outlined text-lg mr-2">calendar_month</i>
                <a href="/my/calendar"><span>Calendrier</span></a>
            </li>
            <li class="d-flex align-items-center p-2"> <!--v-if="this.currentUser.role == 'admin'">-->
                <i class="material-symbols-outlined text-lg mr-2">calendar_month</i>
                <a href="/my/calendar/v2"><span>Calendrier v2</span></a>
            </li>
            <li v-if="this.currentUser.role != 'moderator'" class="d-flex align-items-center p-2">
                <i class="material-symbols-outlined text-lg mr-2">account_balance</i>
                <a href="/my/funds"><span>Caisse</span></a>
            </li>
            <li v-if="this.currentUser.role == 'admin'" class="d-flex align-items-center p-2">
                <i class="material-symbols-outlined text-lg mr-2">groups</i>
                <a href="/my/users"><span>Users</span></a>
            </li>
            <li v-if="['admin', 'moderator'].includes(this.currentUser.role)" class="d-flex align-items-center p-2">
                <i class="material-symbols-outlined text-lg mr-2">sports_soccer</i>
                <a href="/my/admin/matches"><span>Matchs</span></a>
            </li>
            <li class="d-flex align-items-center p-2">
                <span class="position-relative">
                    <i class="material-symbols-outlined text-lg mr-2">notifications</i>
                    <span v-if="unread_notifications.length > 0"
                        class="position-absolute rounded-circle bg-danger border-white" style="top: 0; right: .5rem; width: 6px; height: 6px;"></span>
                </span>
                <a href="/my/notifications"><span>Notifications</span></a>
            </li>
            <hr class="my-2 mx-2" />
            <li class="d-flex align-items-center p-2">
                <i class="material-symbols-outlined text-lg mr-2">manage_accounts</i>
                <a href="/my/profile"><span>Profil</span></a>
            </li>
            <li v-if="!['admin', 'moderator'].includes(currentUser.role)" class="d-flex align-items-center p-2">
                <i class="material-symbols-outlined text-lg mr-2">password</i>
                <a href="/my/change-password"><span>Changer Mot de Passe</span></a>
            </li>
            <li class="d-flex align-items-center p-2">
                <i class="material-symbols-outlined text-lg mr-2">logout</i>
                <a href="#" @click.prevent="logout">
                    <span>Se Déconnecter</span>
                </a>
            </li>
        </ul>
    </nav>
</template>
<script>
export default {
    computed: {
        currentUser() {
            return this.$store.getters.currentUser;
        },
        notifications() {
            const notifications = this.$store.getters.notifications;
            return notifications && Array.isArray(notifications) ? notifications : []
        },
        unread_notifications() {
            const notifications = this.$store.getters.notifications;
            return notifications && Array.isArray(notifications) ? notifications.filter(notification => !notification['is_read']) : []
        },
    },
    methods: {
        logout() {
            this.$store.dispatch("logout");
        },
    },
};
</script>
